/**
 * Created by vladislav on 26.12.2019
 */

const UserStatus = function () {
    cleverapps.EventEmitter.call(this);

    this.timeouts = [];
};

UserStatus.prototype = Object.create(cleverapps.EventEmitter.prototype);
UserStatus.prototype.constructor = UserStatus;

UserStatus.prototype.initTimeouts = function () {
    this.destructor();

    if (cleverapps.environment.isSceneWithPreview()) {
        return;
    }

    this.timeouts = [
        new UserStatusTimeout(cleverapps.parseInterval("3 seconds"), ((type, order) => {
            this.trigger("inactive_extra_short", order);
        })),

        new UserStatusTimeout(cleverapps.parseInterval("10 seconds"), ((type, order) => {
            this.trigger("inactive_very_short", order);
        })),

        new UserStatusTimeout(cleverapps.parseInterval("20 seconds"), ((type, order) => {
            this.trigger("inactive_short", order);
        })),

        new UserStatusTimeout(cleverapps.parseInterval("60 seconds"), ((type, order) => {
            this.trigger("inactive_long", order);
        }))
    ];
};

UserStatus.prototype.destructor = function () {
    this.timeouts.forEach((timeout) => {
        timeout.destructor();
    });

    this.timeouts = [];
};

UserStatus.prototype.reportUserAction = function () {
    this.trigger("active");

    this.timeouts.forEach((timeout) => {
        timeout.reset();
    });
};

const UserStatusTimeout = function (time, callback) {
    this.time = time;
    this.callback = callback;

    this.reset();
};

UserStatusTimeout.prototype.reset = function () {
    this.clear();

    this.hintTimeout = cleverapps.timeouts.setTimeout(() => {
        this.callback();
        this.reset();
    }, this.time);
};

UserStatusTimeout.prototype.clear = function () {
    cleverapps.timeouts.clearTimeout(this.hintTimeout);
};

UserStatusTimeout.prototype.destructor = function () {
    this.clear();
};